export enum OrderStatus {
  Draft = 'DRAFT',
  Placed = 'PLACED',
  Confirmed = 'CONFIRMED',
  Delivered = 'DELIVERED',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Expired = 'EXPIRED',
}
